<template>
  <el-dialog
    :visible.sync="isShow"
    :width="width"
    :show-close="showClose"
    :title="title"
    :append-to-body="appendToBody"
    :before-close="handleClose">
    <div slot="title" class="title" v-if="!title">
      <slot name="title"></slot>
    </div>
    <slot name="main"></slot>
    <div slot="footer" class="dialog-footer">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'commonDialog',
  props: ['value', 'width', 'showClose', 'title', 'center', 'modal', 'appendToBody'],
  data() {
    return {
      isShow: false
    }
  },
  watch: {
    value (val) {
      this.isShow = val
    }
  },
  methods: {
    handleClose () {
      this.$emit('toClose')
    },
  }
}
</script>

<style scoped lang="scss">
  /deep/ .el-dialog__header {
    background-color: var(--themeCyanColor) !important;
    font-size: 20px!important;
    color: #fff!important;
    padding: 16px 16px!important;
    .el-icon-close {
      color: #fff!important;
      font-size: 18px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commonDialog.vue